import React from 'react'
import {
    AllEvents,
    BreakingNewsCard,
    createCardClickedEvent,
    useFeature,
} from '@news-mono/web-common'
import {
    MiniWaFootyLivesHereIcon,
    StyledBackgroundImage,
    StyledFootyLivesHerePromoStrapContainer,
    StyledFootyLivesHereText,
    StyledInnerContainer,
    StyledInnerTextContainer,
} from './FootyLivesHerePromoStrap.styled'

export interface FootyLivesHerePromoStrapProps {
    bannerLink: string
    text: string
    onEvent: (event: AllEvents) => void
    impressionRef: React.RefObject<HTMLDivElement>
}

export const FootyLivesHerePromoStrap = ({
    bannerLink,
    text,
    onEvent,
    impressionRef,
}: FootyLivesHerePromoStrapProps) => {
    const backgroundImg = require('./assets/background-image.jpg')
    const hideOnMobileAndApp = useFeature(
        'hide-mobile-breaking-news-banner',
        true,
    )

    const item: BreakingNewsCard = {
        shortHeadline: 'FOOTY LIVES HERE',
        link: bannerLink,
        cardType: 'breaking-news',
        listId: 'footy-lives-here-promo-strap',
    }
    const linkClicked = () => {
        onEvent(
            createCardClickedEvent(
                onEvent,
                item,
                'FootyLivesHerePromoStrap',
                'FootyLivesHerePromoStrap',
                1,
            ),
        )
    }

    // I want to split the 'text' on the 'FREE' word and wrap it in a span with different styling
    const mappedText: React.ReactNode[] = []

    text.split('FREE').forEach((part, index, array) => {
        mappedText.push(part)

        if (index < array.length - 1) {
            mappedText.push(<span>FREE</span>)
        }
    })

    return (
        <div ref={impressionRef}>
            <StyledFootyLivesHerePromoStrapContainer
                hideOnMobileAndApp={hideOnMobileAndApp}
                href={bannerLink}
                onClick={linkClicked}
            >
                <StyledBackgroundImage
                    src={backgroundImg}
                    alt="background image"
                />
                <StyledInnerContainer>
                    <MiniWaFootyLivesHereIcon />
                    <StyledInnerTextContainer>
                        {mappedText.map((part, index) => (
                            <StyledFootyLivesHereText key={index}>
                                {part}
                            </StyledFootyLivesHereText>
                        ))}
                    </StyledInnerTextContainer>
                    <MiniWaFootyLivesHereIcon />
                </StyledInnerContainer>
            </StyledFootyLivesHerePromoStrapContainer>
        </div>
    )
}
